<div class="knab-header">
  <img ngSrc="assets/images/KNAB.svg" width="60" height="21" alt="KNAB" />
  <div class="payment-request-text">Betaalverzoek</div>
</div>
